module.exports = __webpack_public_path__ + "static/media/Terminos_y_Condiciones_Enviamelo_090919.a417d5fb.pdf";